import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import componentStyles from './outline-pager.css.lit';
import { OutlineElement, LightDomStyles } from '@phase2/outline-core';
import '../outline-icon-baseline/outline-icon-baseline';

/**
 * The OutlinePager component
 * @element outline-pager
 */
@customElement('outline-pager')
export class OutlinePager extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  lightDomStyles = new LightDomStyles(
    this,
    componentStyles,
    this.tagName.toLowerCase()
  );

  updated() {
    if (this.querySelector('.pager__item--previous a')) {
      this.querySelector('.pager__item--previous a')!.innerHTML +=
        '<outline-icon-baseline name="eu-chevron" size=".80rem"></outline-icon-baseline>';
    }
    if (this.querySelector('.pager__item--next a')) {
      this.querySelector('.pager__item--next a')!.innerHTML +=
        '<outline-icon-baseline name="eu-chevron" size=".80rem"></outline-icon-baseline>';
    }
  }

  render(): TemplateResult {
    return html` <slot></slot> `;
  }
}
